<template>
    <main-content >
        <ul class="nav nav-pills" role="tablist">
            <li class="nav-item" @click="changeBoard(0)">
                <router-link :class="['nav-link', tab == 'tickets-list' ? 'active': '']" to="/tickets/tickets-list"
                             data-toggle="tab"
                             role="tab" aria-selected="false"
                             style="cursor:pointer;"
                >
                    {{ $t('dashboard.label.ticket_list') }}
                </router-link>
            </li>

            <li v-if="$can('read', 'ticket')" class="nav-item" @click="changeBoard(1)">
                <router-link :class="['nav-link', tab == 'categories-list' ? 'active': '']" to="/tickets/categories-list"
                             data-toggle="tab"
                             role="tab" aria-selected="false"
                             style="cursor:pointer;"
                >
                    {{ $t('dashboard.label.ticket_category_list') }}
                </router-link>
            </li>
            <li v-if="$can('read', 'ticket')" class="nav-item" @click="changeBoard(2)">
                <router-link :class="['nav-link', tab == 'ticket-settings' ? 'active': '']" to="/tickets/ticket-settings"
                             data-toggle="tab"
                             role="tab" aria-selected="false"
                             style="cursor:pointer;"
                >
                    {{ $t('label.ticket-settings') }}
                </router-link>
            </li>

        </ul>

        <div class="tab-content">
            <div id="tickets-list" :class="['tab-pane', tab == 'tickets-list' ? 'active':'']">
                <ticket-filter :action="filterAction" ></ticket-filter>
                <action-bar>
                    <router-link to="/ticket/create" class="btn btn-success">{{ $t('ticket.btn.add') }}</router-link>
                </action-bar>
                <div v-if="status == 'success' && current_user.username">
                    <kt-datatable v-if="$can('read', 'ticket')" v-bind="datatableProps" ref="datatable"></kt-datatable>
                    <kt-datatable v-else v-bind="commonAccessDatatableProps" ref="datatable"></kt-datatable>
                </div>
            </div>

            <div id="categories-list" v-if="$can('read', 'ticket')" :class="['tab-pane', tab == 'categories-list' ? 'active':'']">
                <category-filter :action="categoryFilterAction" />
                <!--Modal-->
                <button type="button" @click="showModal('create_category_main_cat')" class="btn btn-success mb-3">{{ $t('categories.new_category') }}</button>
                <create-category-modal />
                <div class="bg-white px-3 py-4">
                    <category-list
                        :categories="ticket_categories"
                    />
                </div>
                <!--Emd Modal-->

            </div>

            <div id="ticket-settings" v-if="$can('read', 'ticket')" :class="['tab-pane', tab == 'ticket-settings' ? 'active':'']">
                <ticket-settings></ticket-settings>
            </div>
        </div>
    </main-content>
</template>

<script>
import {ApiUrl, ticketService} from '@/common/api.service'
import columns from './datatable/columns'
import commonAccessColumns from './datatable/commonAccessColumns'
import actions from './datatable/actions'
import { AuthorizationHeader } from '@/common/jwt.service'
import mainContent from '@/components/main-content'
import actionBar from '@/components/custom/action-bar'
import ticketFilter from './components/ticket-filter'
import {mapGetters} from "vuex";
import ticketsList from './components/tickets-list'
import {KTApp} from "@/plugins/core/app";
import Dialog from "@/components/elements/modal/dialog.vue";
import modal from "@/components/elements/modal.vue";
import $ from "jquery"
import CreateCategoryModal from "@/views/ticket/components/create-category-modal.vue";
import toastr from "toastr";
import CategoryList from "@/views/ticket/components/category-list.vue";
import CategoryFilter from "@/views/ticket/components/category-filter.vue";
import TicketSettings from "@/views/ticket/components/ticket-settings.vue";

export default {
    components: {
        TicketSettings,
        CategoryFilter,
        CategoryList,
        CreateCategoryModal,
        mainContent,
        actionBar,
        ticketFilter,
    },
    data() {
        return {
            headerAction: {
                left: '10px',
                top: '10px',
                position: 'absolute'
            },
            query: {}
        }
    },
    beforeRouteEnter (to, from, next) {
        next(vm => {
            vm.$store.dispatch('ticket/fetchCategories')
        })
    },
    computed: {
        modal() {
            return modal
        },
        datatableProps() {
            return {
                id: "user_ticket_datatable_for_admin",
                data: {
                    type: 'remote',
                    source: {
                        read: {
                            url: ApiUrl.path('ticket/admin'),
                            method: 'GET',
                            headers: AuthorizationHeader,
                            map: function(res) {
                                return res.data.data
                            },
                            params: {
                                query: this.query
                            },
                        }
                    },
                    pageSize: 10,
                    serverPaging: true,
                    serverFiltering: true,
                    serverSorting: true,
                },
                layout: {
                },
                pagination: false,
                sortable: true,
                columns: columns,
                actions: actions
            }
        },
        commonAccessDatatableProps() {
            return {
                id: "user_ticket_datatable",
                data: {
                    type: 'remote',
                    source: {
                        read: {
                            url: ApiUrl.path('ticket'),
                            method: 'GET',
                            headers: AuthorizationHeader,
                            map: function(res) {
                                return res.data.data
                            },
                            params: {
                                query: this.query
                            },
                        }
                    },
                    pageSize: 10,
                    serverPaging: true,
                    serverFiltering: true,
                    serverSorting: true,
                },
                layout: {
                },
                pagination: false,
                sortable: true,
                columns: commonAccessColumns,
                actions: actions
            }
        },
        ...mapGetters('ticket', [
            'status', 'ticket_categories'
        ]),
        ...mapGetters('user', [
            'current_user'
        ]),
        tab() {
            if (this.$route.params.tab) {
                return this.$route.params.tab;
            }

            return 'tickets-list';
        },
        toastr() {
            toastr.options = {
                closeButton: true,
                positionClass: "toast-bottom-center",
                preventDuplicates: false,
                rtl: false
            }

            return toastr
        },
    },
    methods: {
        changeBoard(board) {
            if (board == 0 ){
                this.$store.dispatch('ticket/fetchCategories')
            }
            this.board = board;
        },
        filterAction(e, query) {
            this.query = query
            if (this.$refs.datatable.KTDatatable) {
                this.$refs.datatable.reload()
            }
        },
        showModal(id) {
            $('#'+ id).modal('show')
        },
        categoryFilterAction(e, query) {
            let btn = $('#category_filter_btn')

            KTApp.progress(btn)
            this.$store.dispatch('ticket/fetchTicketCategories', query)
                .finally(() => {
                    KTApp.unprogress(btn)
                })
        }
    },
    mounted() {
        this.$store.dispatch('ticket/fetchTicketCategories')
    }
}
</script>

<style>

</style>
